// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__XXj-R","creatorName":"footer_creatorName__M36op"};